// @ts-nocheck
import type { AnimationTrack } from '../../types/animation';
import type { CanvasAnimationStep } from './canvasAnimationBridge';

/** Collect unique timestamps from all tracks, sorted ascending. */
export function collectTrackTimestamps(tracks: AnimationTrack[]): number[] {
  const set = new Set<number>();
  for (const track of tracks) {
    for (const t of track.timesMs) {
      set.add(t);
    }
  }
  return [...set].sort((a, b) => a - b);
}

/** Validate track shape: equal array lengths, non-negative monotonic times. */
export function validateAnimationTracks(tracks: AnimationTrack[]): string | null {
  for (const track of tracks) {
    if (track.timesMs.length !== track.values.length) {
      return `Track ${track.parameter}: timesMs and values length mismatch`;
    }
    for (let i = 1; i < track.timesMs.length; i += 1) {
      if (track.timesMs[i] < track.timesMs[i - 1]) {
        return `Track ${track.parameter}: timesMs must be monotonic non-decreasing`;
      }
    }
  }
  return null;
}

/**
 * Compile parallel tracks into legacy step keyframes at each unique timestamp.
 * Used for backward-compatible step-based consumers.
 */
export function compileTracksToSteps(
  tracks: AnimationTrack[],
  durationMs: number,
): CanvasAnimationStep[] {
  const times = collectTrackTimestamps(tracks);
  if (times.length === 0) {
    return [{ atMs: 0 }, { atMs: durationMs }];
  }
  const unique = new Set([0, ...times, durationMs]);
  return [...unique]
    .sort((a, b) => a - b)
    .map((atMs) => ({ atMs }));
}
